/**
 * @mixin
 */
export default {
	props: {
		/**
		 * Sets the variant of the element.
		 * Represents the global variation of the css
		 * @type {String}
		 */
		state: {
			type: String,
			default: null,
			validator: val => {
				return (
					[
						null,
						'negative',
						'positive',
						'warning',
						'info',
						'mail',
						'time'
					].indexOf(val) >= 0
				);
			}
		}
	},
	data() {
		return {
			stateClasses: {
				negative: 'is-negative',
				positive: 'is-positive',
				warning: 'is-warning',
				info: 'is-info',
				mail: 'is-mail',
				time: 'is-time'
			}
		};
	},
	computed: {
		stateClassList() {
			const classArray = [];

			let vClassArray = this.stateClasses[this.state];

			if (!Array.isArray(vClassArray)) {
				//if only a stirng was passed in, convert to an array
				vClassArray = [vClassArray];
			}

			classArray.push(...vClassArray);

			return classArray;
		}
	}
};
